module.exports = __webpack_public_path__ + "img/news6-3.d8f37701.png";